__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/cfba193/packs/";